import React from 'react';
import { Link } from 'gatsby';
import { injectIntl, intlShape } from 'react-intl';

import LanguageMenu from './languageMenu';
import LogoText from './logoText';
import MenuNarrowDropDown from './menuNarrowDropDown';
import MenuWide from './menuWide';

import { ReactComponent as BlogLogo } from '../images/svgs/blog-logo.svg';
import styles from '../styles/components/header.module.scss';

const Header = ({ intl }) => {
  let currentLanguage = '/';

  if (intl.locale != null) {
    currentLanguage = `/${intl.locale}/`;
  }

  return (
    <header className={styles.container}>
      <div className={styles.languageContainer} >
        <LanguageMenu />
      </div>
      <div className={styles.menu}>
        <div className={styles.homeLink}>
          <Link to={currentLanguage}>
            <div className={styles.logo}>
              <BlogLogo />
              <LogoText />
            </div>
          </Link>
        </div>
        <MenuWide />
        <MenuNarrowDropDown />
      </div>
    </header>
  );
};

Header.propTypes = {
  intl: intlShape.isRequired,
};

export default injectIntl(Header);
